import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles<Theme>(theme => ({
  assigneeNote: {
    color: theme.palette.common.gray600,
    marginTop: theme.spacing(1),
  },
}));
